import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight, Bell } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import { useSeo } from "../lib/useSeo";

const CONFIG = {
  lunettes: {
    label: "Collection Lunettes",
    title: "Le regard sublimé",
    baseline: "Bientôt · Automne 2026",
    description:
      "Une sélection de lunettes solaires et optiques d'exception, entre acétate italien travaillé main et titane léger japonais. Chaque monture est choisie pour la pureté de sa ligne et le confort de son maintien.",
    cta: "M'avertir de la sortie",
    seoTitle: "Collection Lunettes — Bientôt disponible",
    seoDesc: "Lunettes solaires & optiques d'exception — Automne 2026. Sélection MAISON DOUBA en acétate italien et titane japonais.",
  },
  sacs: {
    label: "Collection Sacs",
    title: "Le cuir, l'héritage",
    baseline: "Bientôt · Automne 2026",
    description:
      "Cuirs pleine fleur, façonnés main dans des ateliers d'exception. Des pièces sobres, discrètes, taillées pour durer une vie et se patiner avec grâce.",
    cta: "M'avertir de la sortie",
    seoTitle: "Collection Sacs — Bientôt disponible",
    seoDesc: "Sacs en cuir pleine fleur, façonnés main — Automne 2026. Une sélection MAISON DOUBA d'exception.",
  },
};

export default function ComingSoonPage({ type }) {
  const params = useParams();
  const key = type || params.type;
  const cfg = CONFIG[key];

  useSeo({
    title: cfg?.seoTitle ? `${cfg.seoTitle} · MAISON DOUBA` : "MAISON DOUBA",
    description: cfg?.seoDesc || "MAISON DOUBA — Prochainement.",
    canonical: `https://wwwmaisondouba.com/${key || ""}`,
  });

  if (!cfg) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white">
        <Navbar />
        <div className="pt-40 text-center">
          <h1 className="font-serif text-4xl">Page introuvable</h1>
          <Link to="/" className="text-[color:var(--gold)] hover:underline mt-4 inline-block">Retour</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid={`coming-soon-${key}`}>
      <Navbar />

      {/* Hero */}
      <section className="pt-40 pb-32 md:pb-44 relative overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0d0906] to-[#0A0A0A]" />
        <div className="relative max-w-[1200px] mx-auto px-6 md:px-12 text-center">
          <p className="label-caps text-[color:var(--gold)] text-[11px] tracking-[0.3em] mb-6">{cfg.label}</p>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-tight mb-8">
            <em className="italic text-[color:var(--gold-soft)]">{cfg.title}</em>.
          </h1>
          <p className="text-[color:var(--gold)] label-caps text-[11px] tracking-[0.4em] mb-10">{cfg.baseline}</p>
          <p className="text-white/60 font-light max-w-xl mx-auto text-base leading-relaxed mb-14">
            {cfg.description}
          </p>

          <div className="flex items-center justify-center gap-4">
            <a
              href="#newsletter"
              data-testid={`coming-soon-cta-${key}`}
              className="inline-flex items-center gap-3 border border-[color:var(--gold)] text-[color:var(--gold)] px-8 py-4 label-caps text-[11px] tracking-[0.3em] hover:bg-[color:var(--gold)] hover:text-black transition-colors"
            >
              <Bell size={14} /> {cfg.cta} <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <div id="newsletter">
        <Newsletter />
      </div>

      <Footer />
    </div>
  );
}
